import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { redirectToRoute } from '../actions.js';
import RakutenLoader from './RakutenLoader.jsx';

class Index extends Component {
    static propTypes = {
        advertisableEid: PropTypes.string,
        dispatch: PropTypes.func,
        strategy: PropTypes.object,
        finishedLoadingStrategy: PropTypes.bool,
        aggregatePerformance: PropTypes.object
    }

    componentWillMount() {
        this.redirect();
    }

    componentDidMount() {
        this.redirect();
    }

    render() {
        return <RakutenLoader className='strategy-loader' />;
    }

    redirect() {
        const { dispatch, finishedLoadingStrategy } = this.props;
        if (finishedLoadingStrategy) {
            dispatch(redirectToRoute(`${process.env.ROOT_PATH}dashboard`));
        }
    }

}

export default Index;
